/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_CancellationInputs */

const en_admin_resource_form_cancellation = /** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation`)
};

const de_admin_resource_form_cancellation = /** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierung`)
};

const es_admin_resource_form_cancellation = /** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación`)
};

const fr_admin_resource_form_cancellation = /** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation`)
};

const nl_admin_resource_form_cancellation = /** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulering`)
};

/** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */
const it_admin_resource_form_cancellation = en_admin_resource_form_cancellation;

/** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */
const pt_br2_admin_resource_form_cancellation = en_admin_resource_form_cancellation;

/** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */
const pl_admin_resource_form_cancellation = en_admin_resource_form_cancellation;

/** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */
const hu_admin_resource_form_cancellation = en_admin_resource_form_cancellation;

/** @type {(inputs: Admin_Resource_Form_CancellationInputs) => LocalizedString} */
const ro_admin_resource_form_cancellation = en_admin_resource_form_cancellation;

/**
* | output |
* | --- |
* | "Cancellation" |
*
* @param {Admin_Resource_Form_CancellationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_cancellation = /** @type {((inputs?: Admin_Resource_Form_CancellationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_CancellationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_cancellation(inputs)
	if (locale === "de") return de_admin_resource_form_cancellation(inputs)
	if (locale === "es") return es_admin_resource_form_cancellation(inputs)
	if (locale === "fr") return fr_admin_resource_form_cancellation(inputs)
	if (locale === "nl") return nl_admin_resource_form_cancellation(inputs)
	if (locale === "it") return it_admin_resource_form_cancellation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_cancellation(inputs)
	if (locale === "pl") return pl_admin_resource_form_cancellation(inputs)
	if (locale === "hu") return hu_admin_resource_form_cancellation(inputs)
	return ro_admin_resource_form_cancellation(inputs)
});
export { admin_resource_form_cancellation as "admin.resource_form.cancellation" }